import { render, staticRenderFns } from "./IconAwardCup.vue?vue&type=template&id=5153b98b"
import script from "./IconAwardCup.vue?vue&type=script&lang=js"
export * from "./IconAwardCup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports